<template>
  <div class="home">
    <Loading ref="loading"></Loading>
    <div class="banner">
      <img v-if="prizeInfo?.banner_img" :src="prizeInfo.banner_img" />
      <img v-else src="../../assets/banner2.jpg" />
    </div>
    <div class="card" v-if="isInit">
      <!-- 主内容 -->
      <div class="main">
        <!-- 游戏信息 -->
        <div v-if="game && isJoin" class="game-info">
          <div class="value">{{ game?.papp_name }}</div>
          <div class="select-game" @click="handleSelectGame">【更换游戏】</div>
        </div>
        <!-- 角色信息【直达礼包需要绑定角色】 -->
        <div class="role-info" v-if="game?.direct_gift">
          <div v-show="role && isJoin" class="server-name">
            {{ role?.server_name }}
          </div>
          <div v-show="!(role && isJoin)" class="server-name">未绑定角色</div>
          <div class="role-name">
            <div v-show="role && isJoin" class="value">
              {{ role?.role_name }}
            </div>
            <div
              v-if="!(role && isJoin)"
              class="bind-btn"
              @click="handleSelectRole"
            >
              【绑定角色】
            </div>
            <div v-else class="bind-btn" @click="handleSelectRole">
              【换绑角色】
            </div>
          </div>
        </div>
        <!-- 退出 -->
        <div v-if="!!userInfo && isJoin" class="logout">
          <span @click="handleLogout" class="logout-btn">退出账号</span>
        </div>
        <!-- 团队信息 -->
        <div class="team-info">
          <div class="label">团队信息</div>
          <!-- 开始 -->
          <div v-if="!isJoin" class="begin">
            <Button @click="handleNext('master')" width="15rem" height="2.5rem"
              >成为团长</Button
            >
            <div class="tip">成为团长后，无法加入其他队伍，请确认后操作</div>
            <div class="join">
              <div class="label">加入队伍</div>
              <div class="input-wrapper">
                <Input
                  :modelValue="inviteCode"
                  @update:modelValue="(v) => (inviteCode = v)"
                  name="groupId"
                  placeholder="输入邀请码"
                ></Input>
                <Button
                  class="confirm-btn"
                  height="2rem"
                  @click="handleNext('member')"
                  >确认</Button
                >
              </div>
            </div>
          </div>
          <!-- 已加入团队 -->
          <div v-else class="team-bar">
            <div class="master">
              <img class="avatar" :src="master.avatar" />
              <Button
                class="tag"
                height="1.8rem"
                width="5.5rem"
                background="@/assets/btn-bg-s.png"
                >团长</Button
              >
              <div class="name">{{ master.name }}</div>
            </div>
            <div class="members">
              <Button
                v-for="i in [0, 1, 2, 3]"
                :key="i"
                width="13rem"
                height="2.4rem"
                class="member"
                @click="handleInvite"
                :class="!members[i] ? 'vacant' : ''"
              >
                <img
                  v-if="members[i]"
                  :src="members[i].wechat_avatar_url"
                  class="member-avatar"
                />
                <img class="icon" src="../../assets/invite.png" />
                {{ members[i] ? members[i].wechat_nickname : "邀请入队" }}
              </Button>
            </div>
            <div class="invite-code">
              <div class="code">
                <div>队伍邀请码：</div>
                <div class="value">{{ groupId.replace(/rebate:/g, "") }}</div>
              </div>
              <Button
                class="copy-btn"
                width="3.2rem"
                height="1.4rem"
                @click="copyInviteCode"
                >复制</Button
              >
            </div>
          </div>
        </div>
        <!-- 奖品信息 -->
        <div class="prize-info" v-if="isJoin">
          <!-- <div class="label">活动奖励</div>
          <div class="tip">2023年1月1日 10点后可领取返利</div> -->
          <!-- 奖品列表 -->
          <div class="prize-list">
            <div
              class="prize"
              v-for="prize in prizeInfo.img_list"
              :key="prize.name + prize.icon"
            >
              <img :src="prize.icon" />
              <div class="name">{{ prize.name }}</div>
            </div>
          </div>
          <!-- 操作 -->
          <div class="operations">
            <Button
              @click="handleShowPrize"
              class="operation"
              width="21rem"
              height="2.5rem"
              >查看返利</Button
            >
            <Button
              width="21rem"
              height="2.5rem"
              @click="$refs.gotLogDialog.open({ app_type: getGameType() })"
              >领取记录</Button
            >
          </div>
        </div>
      </div>
      <!-- 活动规则 -->
      <div class="rules">
        <div class="label">活动规则</div>
        <div class="rule-content" v-html="rule"></div>
      </div>
    </div>
    <!-- 交互相关 -->
    <LoginOptionDialog ref="loginOptionDialog"></LoginOptionDialog>
    <SelectGame
      :current="game?.papp_id"
      ref="selectGame"
      @select="onSelectGame"
    />
    <SelectRole
      :default="this.role?.role_id"
      ref="selectRole"
      @select="onSelectRole"
      @close="onRoleClose"
    />
    <GotLogDialog ref="gotLogDialog" />
    <InviteTip @close="showInviteTip = false" v-if="showInviteTip" />
    <GetPrizeDialog ref="getPrizeDialog" />
    <RoleInputDialog
      @confirm="onSelectRole"
      ref="roleInputDialog"
      @help="showHelp"
    />
    <HelpDialog ref="helpDialog" @close="$refs.roleInputDialog.open()" />
    <NoWxClientTip />
  </div>
</template>

<script>
import NoWxClientTip from "./components/NoWxClientTip.vue";
import HelpDialog from "./components/HelpDialog.vue";
import Clipboard from "clipboard";
import RoleInputDialog from "./components/RoleInputDialog.vue";
import InviteTip from "./components/InviteTip.vue";
import SelectGame from "./components/SelectGame.vue";
import SelectRole from "./components/SelectRole.vue";
import LoginOptionDialog from "./components/LoginOptionDialog.vue";
import GetPrizeDialog from "./components/GetPrizeDialog.vue";
import GotLogDialog from "./components/GotLogDialog.vue";
import Button from "@/components/button/index.vue";
import Input from "@/components/input/index.vue";
import Loading from "@/components/loading/index.vue";
// eslint-disable-next-line no-undef
const wxApi = wx;
export default {
  components: {
    Input,
    Button,
    Loading,
    RoleInputDialog,
    InviteTip,
    LoginOptionDialog,
    SelectGame,
    SelectRole,
    GotLogDialog,
    GetPrizeDialog,
    HelpDialog,
    NoWxClientTip,
  },
  data() {
    return {
      // 用户信息
      master: {},
      // 团队信息
      groupInfo: null,
      // 团队ID
      groupId: null,
      // 队员
      members: [],
      // 奖品信息
      prizeInfo: {
        list: [
          {
            id: 1,
            name: "奖品1",
            img: "",
          },
          {
            id: 2,
            name: "奖品2",
            img: "",
          },
          {
            id: 3,
            name: "奖品1",
            img: "",
          },
          {
            id: 4,
            name: "奖品2",
            img: "",
          },
        ],
      },
      // 选择的游戏
      game: null,
      // 选择的角色
      role: null,
      // 邀请码
      inviteCode: "",
      // 活动规则
      rule: "",
      // 用户身份
      position: null,
      // 显示邀请提示
      showInviteTip: false,
      //初始化成功
      isInit: false,
      // 用户信息
      userInfo: false,
      // 活动状态 0 未开始 1 进行中 2 已结束
      activityStatus: 0,
    };
  },
  computed: {
    shareData() {
      return {
        title: "【队友邀请】星辉618赏金赛",
        link:
          "https://m.rastargame.com/rebate?groupId=" +
          this.groupId.replace("rebate:", ""),
        imgUrl: "https://m.rastargame.com/rebateSharImg/share.jpg",
        desc: "加入我的队伍，一起领取充值返利！",
      };
    },
    isJoin() {
      return this.groupInfo?.group_id;
    },
  },
  methods: {
    // 王者猎人（如何获取用户信息）
    showHelp() {
      this.$refs.helpDialog.open();
      this.$refs.roleInputDialog.close();
    },
    // 开启返利信息弹窗
    handleShowPrize() {
      this.$refs.getPrizeDialog.open(
        this.game,
        this.role,
        this.groupInfo,
        this.prizeInfo
      );
    },
    // 开启开团或入团
    handleNext(position) {
      const next = () => {
        this.$refs.loading.show("正在获取活动状态...");
        this.getActivityStatus()
          .then((res) => {
            if (res) {
              this.$refs.loginOptionDialog.open(position, this.inviteCode);
            }
          })
          .catch(() => {
            this.$toast("网络异常，请稍后重试");
          })
          .finally(() => {
            this.$refs.loading.hide();
          });
      };

      if (position === "member") {
        const inviteCode = (this.inviteCode || "").trim();
        // 成员，获取邀请码
        if (inviteCode.length === 0) {
          this.$toast("请输入邀请码");
          return;
        }

        this.$refs.loading.show("正在获取队伍信息...");
        let data = {
          tm: Date.parse(new Date()),
          group_id: "rebate:" + inviteCode,
          con_id: this.$xh.xhParams.con_id,
          version: this.$xh.xhParams.version,
          nonce: this.$xh.nonce(),
        };
        data.sign = this.$RSSign(data, this.$xh.xhParams.key);

        this.$ajax({
          method: "get",
          url: this.$api.v2.getGroupInfo,
          params: data,
        })
          .then((res) => {
            if (res.data.code == 200) {
              next();
            } else if (res.data.code == 6001) {
              this.$refs.loading.hide();
              this.$toast(res.data.msg);
            }
          })
          .catch(() => {
            this.$toast("网络异常，请稍后重试");
            this.$refs.loading.hide();
          }).finally(() => {
            this.$refs.loading.hide();
          });
      } else {
        next();
      }
    },
    // 开启选择游戏
    handleSelectGame() {
      if (this.game?.papp_id === 338 && this.role?.role_id) {
        this.$toast("已绑定末世王者，不支持更换游戏");
        return;
      }
      this.$refs.selectGame.open({ app_type: this.getGameType() });
    },
    // 开启选择角色
    handleSelectRole() {
      if (this.game?.papp_id === 338) {
        if (this.role?.role_id) {
          this.$toast("当前游戏不支持更换角色");
        } else {
          this.$refs.roleInputDialog.open(this.game);
        }
        return;
      }
      this.$refs.selectRole.open(this.game);
    },
    // 选择游戏事件
    onSelectGame(game) {
      if (this.game?.papp_id !== game.papp_id) this.role = null;
      this.game = game;
      if (this.isJoin) this.updateInfo(true);
      if (game.papp_id === 338) {
        // 末世王者让用户自己输入
        this.$refs.roleInputDialog.open(game);
      } else if (!game.direct_gift) {
        // 非直达礼包，无需选择角色
        if (!this.isJoin) {
          this.onGameRoleSelect();
        }
      } else {
        this.handleSelectRole();
      }
      // 切换游戏后奖品不一样，需要重新获取奖品信息
      this.getPrizeInfo();
    },
    // 选择角色事件
    onSelectRole(role) {
      this.role = role;
      this.onGameRoleSelect();
    },
    // 选角关闭
    onRoleClose() {
      if (!this.isJoin) {
        this.onGameRoleSelect();
      }
    },
    // 游戏或角色选择完成
    onGameRoleSelect() {
      if (this.isJoin && this.game) {
        this.updateInfo();
        return;
      }
      // 完成建团/入团前步骤，开始创建/加入团队
      if (this.position === "master") {
        this.handleCreateGroup();
      } else {
        this.joinGroup();
      }
    },
    // 显示邀请提示
    handleInvite() {
      new Promise((resolve, reject) => {
        let data = {
          tm: Date.parse(new Date()),
          con_id: this.$xh.xhParams.con_id,
          version: this.$xh.xhParams.version,
          nonce: this.$xh.nonce(),
        };
        data.sign = this.$RSSign(data, this.$xh.xhParams.key);
        this.$ajax({
          method: "get",
          url: this.$api.getWechat,
          params: {
            remark: "sy-top",
            redirect_url: window.location.href,
          },
        })
          .then((res) => {
            resolve(res.data);
          })
          .catch((err) => {
            reject(err);
          });
      }).then((data) => {
        this.showInviteTip = true;
        let wxData = data;
        wxData.jsApiList = ["onMenuShareTimeline", "onMenuShareAppMessage"];
        wxApi.config({
          debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
          appId: wxData.appId, // 必填，公众号的唯一标识
          timestamp: wxData.timestamp, // 必填，生成签名的时间戳
          nonceStr: wxData.nonceStr, // 必填，生成签名的随机串
          signature: wxData.signature, // 必填，签名
          jsApiList: wxData.jsApiList, // 必填，需要使用的 JS 接口列表
        });
        wxApi.ready(() => {
          wxApi.onMenuShareTimeline({
            title: this.shareData.title,
            link: this.shareData.link,
            imgUrl: this.shareData.imgUrl,
            success: function () {
              // 分享到朋友圈 用户确认分享后执行的回调函数
              console.log("分享到朋友圈ok");
            },
            fail: function (res) {
              console.log("分享到朋友圈==", JSON.stringify(res));
            },
          });
          wxApi.onMenuShareAppMessage({
            title: this.shareData.title,
            link: this.shareData.link,
            imgUrl: this.shareData.imgUrl,
            desc: this.shareData.desc,
            success: function () {
              // 分享给朋友 用户确认分享后执行的回调函数
              console.log("分享给朋友，ok");
            },
            fail: function (res) {
              console.log("分享给朋友==", JSON.stringify(res));
            },
          });
        });
        wxApi.error((err) => {
          console.log(err);
        });
      });
    },
    // 获取用户团队信息接口
    getUserGroupInfo() {
      let data = {
        tm: Date.parse(new Date()),
        con_id: this.$xh.xhParams.con_id,
        version: this.$xh.xhParams.version,
        nonce: this.$xh.nonce(),
        app_type: this.getGameType(),
      };
      data.sign = this.$RSSign(data, this.$xh.xhParams.key);
      this.$ajax({
        method: "get",
        url: this.$api.v2.getUserGroupInfo,
        params: data,
      }).then((res) => {
        if (res.data.code == 200) {
          this.members = (res.data.data || []).filter((m) => m.role_type === 0);
        }
      });
    },
    // 获取礼包信息
    getPrizeInfo() {
      let data = {
        tm: Date.parse(new Date()),
        con_id: this.$xh.xhParams.con_id,
        version: this.$xh.xhParams.version,
        nonce: this.$xh.nonce(),
        // app_type: this.getGameType(),
        papp_id: this.game.papp_id,
      };
      data.sign = this.$RSSign(data, this.$xh.xhParams.key);
      this.$ajax({
        method: "get",
        url: this.$api.v2.homeRewardList,
        params: data,
      }).then((res) => {
        if (res.data.code == 200) {
          this.prizeInfo = res.data.data;
        }
      });
    },
    // 获取团队信息
    getGroupInfo() {
      this.$refs.loading.show("加载中...");
      return new Promise((resolve) => {
        let data = {
          tm: Date.parse(new Date()),
          group_id: this.groupId,
          con_id: this.$xh.xhParams.con_id,
          version: this.$xh.xhParams.version,
          nonce: this.$xh.nonce(),
        };
        data.sign = this.$RSSign(data, this.$xh.xhParams.key);
        this.$ajax({
          method: "get",
          url: this.$api.v2.getGroupInfo,
          params: data,
        }).then((res) => {
          this.$refs.loading.hide();
          if (res.data.code == 200) {
            this.groupInfo = res.data.data;
            this.master = {
              avatar: res.data.data.wechat_avatar_url,
              name: res.data.data.wechat_nickname,
            };
            this.groupId = res.data.data.group_id.replace("rebate:", "");
            resolve(res.data.data);
            this.updatePath();
          } else if (res.data.code == 6001) {
            // 队伍不存在
            this.$router.push({
              name: "Err",
            });
          }
        });
      });
    },
    // 复制邀请码
    copyInviteCode() {
      const clipboard = new Clipboard(".invite-code", {
        text: () => {
          return this.groupId.replace(/rebate:/g, "");
        },
      });
      clipboard.on("success", () => {
        this.$toast("复制成功，快去邀请小伙伴来加入队伍吧!");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", () => {
        this.$toast("复制失败, 请手动复制!");
        this.joinLink = true;
        clipboard.destroy();
      });
    },
    // 获取游戏列表
    getGameList() {
      const params = {
        tm: Date.now(),
        con_id: this.$xh.xhParams.con_id,
        version: this.$xh.xhParams.version,
        nonce: this.$xh.nonce(),
        app_type: this.getGameType(),
      };
      params.sign = this.$RSSign(params, this.$xh.xhParams.key);
      return this.$ajax({
        method: "get",
        url: this.$api.v2.gameList,
        params,
      }).then((res) => {
        if (res.data.code === 200) {
          return res.data.data;
        } else {
          this.$toast(res.data.msg);
          return null;
        }
      });
    },
    // 判断用户是否有团队
    getUserInfo() {
      let _gameList = null;
      return (
        this.getGameList()
          // 获取用户信息
          .then((gameList) => {
            if (gameList && Array.isArray(gameList)) {
              _gameList = gameList;
              const data = {
                tm: Date.parse(new Date()),
                con_id: this.$xh.xhParams.con_id,
                version: this.$xh.xhParams.version,
                nonce: this.$xh.nonce(),
                app_type: this.getGameType(),
              };
              data.sign = this.$RSSign(data, this.$xh.xhParams.key);
              return this.$ajax({
                method: "get",
                url: this.$api.v2.getUserInfo,
                params: data,
              });
            }
            return null;
          })
          .then((res) => {
            if (!res) return false;
            if (res.data.code == 200) {
              this.userInfo = res.data.data;
              // 用户若已有团队，直接跳转团队页面
              if (!res.data.data.flag && res.data.data.group_id) {
                this.groupId = res.data.data.group_id;
                this.role = {
                  role_name: res.data.data.role_name,
                  role_id: res.data.data.role_id,
                  server_id: res.data.data.server_id,
                  server_name: res.data.data.server_name,
                };
                this.game = _gameList.find((g) => {
                  return g.papp_id === res.data.data.papp_id;
                });

                return true;
              } else {
                return false;
              }
            } else if (!/未登录/.test(res.data.msg)) {
              this.$toast(res.data.msg);
              return false;
            }
          })
      );
    },
    // 获取游戏类型
    getGameType() {
      return localStorage.getItem("game_type");
    },
    // 检查是否登录
    checkIsLogin() {
      const uid = localStorage.getItem("uid");
      return (
        (uid && this.getGameType() === "sy") || this.getGameType() === "xyx"
      );
    },
    // 退出登录
    handleLogout() {
      this.$refs.loading.show('正在退出...');
      this.$ajax({
        method: "get",
        url: this.$api.v2.logout,
      }).then((res) => {
        if (res.data.code == 200) {
          localStorage.removeItem("uid");
          if (this.getGameType() === "xyx")
            localStorage.removeItem("game_type");
          window.location.href = window.location.href + "";
        } else {
          this.$toast(res.data.msg);
        }
      }).finally(() => {
        this.$refs.loading.hide();
      });
    },
    // 开团
    handleCreateGroup() {
      this.$refs.loading.show("正在创建队伍...");
      const wxUserInfo = this.$xh.getWxUserInfo();

      if (!wxUserInfo) return;
      let data = {
        tm: Date.parse(new Date()),
        papp_id: this.game.papp_id,
        app_type: this.getGameType(),
        wechat_nickname: encodeURIComponent(wxUserInfo.nickname),
        wechat_avatar_url: wxUserInfo.headimgurl,
        con_id: this.$xh.xhParams.con_id,
        version: this.$xh.xhParams.version,
        nonce: this.$xh.nonce(),
      };
      if (this.role?.server_id) data.server_id = this.role.server_id;
      if (this.role?.role_id) data.role_id = this.role.role_id;
      if (this.role?.app_id) data.app_id = this.role.app_id;
      if (this.role?.cch_id) data.cch_id = this.role.cch_id;
      data.sign = this.$RSSign(data, this.$xh.xhParams.key);
      this.$ajax({
        method: "post",
        url: this.$api.v2.getOpenGroup,
        params: data,
      })
        .then((res) => {
          if (res.data.code == 200) {
            this.$toast("开团成功");
            this.groupId = res.data.data.group_id;
            this.loadGroupInfo();
            this.updatePath();
          } else {
            this.$toast(res.data.msg);
            this.reset("master", this.groupId);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast("创建失败，请稍后重试");
          this.reset("master", this.groupId);
        })
        .finally(() => {
          this.$refs.loading.hide();
        });
    },
    // 入团
    joinGroup() {
      const wxUserInfo = this.$xh.getWxUserInfo();
      if (!wxUserInfo) return;
      this.$refs.loading.show("正在加入队伍...");
      this.getGroupInfo()
        .then((res) => {
          console.log(res);

          let data = {
            tm: Date.parse(new Date()),
            papp_id: this.game.papp_id,
            group_id: res.group_id,
            con_id: this.$xh.xhParams.con_id,
            version: this.$xh.xhParams.version,
            nonce: this.$xh.nonce(),
            wechat_nickname: encodeURIComponent(wxUserInfo.nickname),
            wechat_avatar_url: wxUserInfo.headimgurl,
            app_type: this.getGameType(),
          };
          if (this.role?.server_id) data.server_id = this.role.server_id;
          if (this.role?.role_id) data.role_id = this.role.role_id;
          if (this.role?.app_id) data.app_id = this.role.app_id;
          if (this.role?.cch_id) data.cch_id = this.role.cch_id;
          data.sign = this.$RSSign(data, this.$xh.xhParams.key, true);
          this.$ajax({
            method: "post",
            url: this.$api.v2.joinGroup,
            params: data,
          })
            .then((res) => {
              if (res.data.code === 200) {
                // 允许开团
                this.groupId = res.data.data.group_id;
                this.$toast("入团成功");
                this.loadGroupInfo();
                this.updatePath();
              } else {
                this.$toast(res.data.msg);
                this.reset("member", this.groupId);
              }
            })
            .catch((err) => {
              console.log(err);
              this.$toast("入团失败，请稍后重试");
              this.reset("member", this.groupId);
            })
            .finally(() => {
              this.$refs.loading.hide();
            });
        })
        .catch(() => {
          this.$toast("网络异常，请刷新重试");
        })
        .finally(() => {
          this.$refs.loading.hide();
        });
    },
    // 重置
    reset(position, groupId = "") {
      this.game = null;
      this.role = null;
      this.groupInfo = null;
      this.inviteCode = groupId.replace("rebate:", "");
      if (position && groupId) this.updatePath(groupId);
    },
    // 加载团队信息
    loadGroupInfo() {
      return this.getGroupInfo()
        .then(() => {
          return this.getUserGroupInfo();
        })
        .then(() => {
          return this.getPrizeInfo();
        });
    },
    // 获取活动状态
    getActivityStatus() {
      const params = {
        tm: Date.now(),
        con_id: this.$xh.xhParams.con_id,
        version: this.$xh.xhParams.version,
        nonce: this.$xh.nonce(),
      };
      params.sign = this.$RSSign(params, this.$xh.xhParams.key);
      return this.$ajax({
        method: "get",
        url: this.$api.v2.getActivityStatus,
        params,
      }).then((res) => {
        if (res.data.code !== 200) {
          this.$toast(res.data.msg);
          return false;
        } else if (res.data.data.flag) {
          return true;
        } else {
          this.$toast(res.data.msg);
          return false;
        }
      });
    },
    // 获取规则
    getRules() {
      const params = {
        tm: Date.parse(new Date()),
        con_id: this.$xh.xhParams.con_id,
        version: this.$xh.xhParams.version,
        nonce: this.$xh.nonce(),
      };
      params.sign = this.$RSSign(params, this.$xh.xhParams.key);
      return this.$ajax({
        method: "get",
        url: this.$api.v2.getRules,
        params,
      }).then((res) => {
        if (res.data.code === 200) {
          this.rule = res.data.data.msg;
        } else {
          console.log(res);
        }
      });
    },
    // 初始化
    init() {
      // 查询参数
      const { position, groupId } = this.$xh.pareUrl(window.location.href);
      this.inviteCode = groupId;
      // 加载规则
      // 检查登录 -> 检查开团状态 -> 开团
      this.$refs.loading.show("加载中...");
      this.getRules()
        .then(() => {
          return this.checkIsLogin();
        })
        .then((isLogin) => {
          if (isLogin) {
            // 获取用户是否开团，并加载用户开团信息
            return this.getUserInfo().then((isJoin) => {
              return { isLogin, isJoin };
            });
          } else {
            console.log("未登录");
            this.reset(position, groupId);
            return { isLogin, isJoin: false };
          }
        })
        .then(({ isLogin, isJoin }) => {
          if (!isLogin) return;
          if (isJoin) {
            if (position) this.updatePath(groupId);
            return this.loadGroupInfo();
          } else {
            console.log("未开团");
            this.position = position;
            this.groupId = groupId;
            // 团长身份，选择游戏开团
            if (position && !!this.getGameType()) {
              if (this.position === "member")
                this.groupId = "rebate:" + groupId;
              this.updatePath(this.groupId);
              this.handleSelectGame();
            }
          }
        })
        .catch(() => {
          this.$toast("网络异常，请刷新重试");
        })
        .finally(() => {
          this.$refs.loading.hide();
          this.isInit = true;
        });
    },
    // 更新游戏、角色信息
    updateInfo(onlyGame = false) {
      this.$refs.loading.show("更新中...");
      const data = {
        tm: Date.parse(new Date()),
        papp_id: this.game.papp_id,
        con_id: this.$xh.xhParams.con_id,
        version: this.$xh.xhParams.version,
        nonce: this.$xh.nonce(),
        app_type: this.getGameType(),
      };
      if (!onlyGame) {
        if (this.role?.server_id) data.server_id = this.role?.server_id;
        if (this.role?.role_id) data.role_id = this.role?.role_id;
        if (this.role?.app_id) data.app_id = this.role.app_id;
        if (this.role?.cch_id) data.cch_id = this.role.cch_id;
      }
      data.sign = this.$RSSign(data, this.$xh.xhParams.key, true);
      return this.$ajax({
        method: "get",
        url: this.$api.v2.updateInfo,
        params: data,
      })
        .then((res) => {
          this.getUserInfo();
          if (res.data.code === 200) {
            return true;
          } else {
            this.$toast(res.data.msg);
            return false;
          }
        })
        .catch(() => {
          this.router.push({
            name: "Err",
          });
        })
        .finally(() => {
          this.$refs.loading.hide();
        });
    },
    updatePath(groupId = this.groupId) {
      if (!groupId) return;
      groupId = groupId.replace("rebate:", "");
      if (
        this.$route.query.groupId &&
        this.$route.query.groupId + "" === groupId + ""
      )
        return;
      window.location.href = this.$router.resolve({
        name: "OpenGroup",
        query: {
          groupId,
        },
      }).href;
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
@import "../../sass/color.scss";
.label {
  font-weight: bold;
  font-size: 1.1rem;
}
.home {
  user-select: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: rgb(237, 237, 237);
  font-size: 1rem;
  box-sizing: border-box;
}
.banner {
  width: 100%;
  height: 57vw;
  border-radius: 0.5rem;
  min-width: 23.5rem;
  min-height: 14.35rem;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.card {
  min-width: 23.5rem;
  width: 100%;
  height: 100%;
  background: url(../../../src/assets/bg.png) repeat;
  background-size: 100% auto;
  background-position: 0 -10rem;
  padding: 1rem;
  border-radius: 0.5rem;
  box-sizing: border-box;
}
.main {
  width: 100%;
  height: 100%;
  .game-info {
    display: flex;
    justify-content: space-between;
    padding: 1rem 2rem;
    box-sizing: border-box;
    text-wrap-mode: nowrap;
    font-size: 1.2rem;
    .value {
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .select-game {
      cursor: pointer;
      color: $themeColor;
    }
  }
  .logout {
    width: 100%;
    margin: 1rem 0;
    font-size: 1.2rem;
    font-weight: 100;
    text-align: center;
    .logout-btn {
      padding: 0.5rem;
      text-decoration: underline;
    }
  }
  .role-info {
    gap: 2rem;
    justify-content: center;
    display: flex;
    text-wrap-mode: nowrap;
    .server-name {
      font-size: 1.2rem;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .role-name {
      font-size: 1.2rem;
      display: flex;
      .value {
        text-wrap-mode: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .bind-btn {
        text-wrap-mode: nowrap;
        cursor: pointer;
      }
    }
  }
  .team-info {
    margin-top: 1rem;

    .begin,
    .team-bar {
      display: flex;
      align-items: center;
      flex-direction: column;
      margin-top: 2rem;
    }
    .begin {
      margin-bottom: 4rem;
      .tip {
        color: red;
        margin: 1.5rem 0;
        font-size: 1rem;
      }
      .join {
        margin-top: 1.5rem;
        width: 80%;
        padding: 1rem;
        background: white;
        border: 0.01rem solid rgb(227, 227, 227);
        border-radius: 0.5rem;
        .input-wrapper {
          margin-top: 0.2rem;
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 1rem;
          :deep(.input) {
            background: rgb(242, 242, 242);
            height: 2.5rem;
            padding: 0.2rem 0.3rem;
            box-sizing: border-box;
            position: relative;
            left: -0.3rem;
            border-radius: 0.6rem;
            font-size: 0.8rem;
          }
          .confirm-btn {
            flex-shrink: 0;
            border-radius: 0.5rem;
          }
        }
      }
    }
    .master {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      .avatar {
        border: 1px solid $themeColor;
        width: 6.5rem;
        height: 6.5rem;
        padding: 0.2rem;
        background: rgb(242, 242, 242);
        box-sizing: border-box;
      }
      .tag {
        background: url(../../assets/master-tag.png) no-repeat center;
        background-size: contain;
        position: relative;
        top: -0.8rem;
      }
      .name {
        font-size: 1rem;
        color: #999;
        position: relative;
        top: -0.1rem;
      }
    }
    .members {
      min-width: 23.5rem;
      position: relative;
      width: 100vw;
      height: 7rem;
      display: grid;
      justify-content: center;
      grid-template-columns: repeat(2, 15rem);
      row-gap: 2rem;
      column-gap: 0.8rem;
      margin-top: 1rem;
      .member {
        position: absolute;
        pointer-events: none;
        gap: 1rem;
        &.vacant {
          pointer-events: all;
          .member-avatar {
            display: none;
          }
          .icon {
            visibility: visible;
          }
        }
        .member-avatar {
          width: 3.6rem;
          height: 3.6rem;
          position: absolute;
          background: white;
          padding: 0.1rem;
          border: 1px solid $themeColor;
        }
        .icon {
          visibility: hidden;
          width: 1.6rem;
        }
        &:nth-child(2n-1) {
          left: -1rem;
          background: url(../../assets/invite-l.png) no-repeat left;
          background-size: contain;
          flex-direction: row-reverse;
          .member-avatar {
            right: 0.5rem;
          }
        }

        &:nth-child(2n) {
          right: -1rem;
          background: url(../../assets/invite-r.png) no-repeat right;
          background-size: contain;
          .member-avatar {
            left: 0.5rem;
          }
        }

        &:nth-child(3),
        &:nth-child(4) {
          top: 4.5rem;
        }
      }
    }
    .invite-code {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin-top: 2rem;
      padding: 0 1.8rem;
      gap: 3rem;
      .code {
        .value {
          user-select: all;
        }
        text-wrap-mode: nowrap;
        font-size: 0.8rem;
        display: flex;
        align-items: center;
        border-radius: 2rem;
        height: 2.2rem;
        width: 100%;
        color: #aaa;
        background: rgb(242, 242, 242);
        padding: 0 2rem;
      }
      .copy-btn {
        flex-shrink: 0;
        font-size: 0.8rem;
      }
    }
  }
  .prize-info {
    margin-top: 1rem;
    .tip {
      color: #aaa;
      margin-top: 1rem;
    }
    .prize-list {
      display: flex;
      margin-top: 1rem;
      justify-content: center;
      flex-wrap: wrap;
      gap: 1rem;
      .prize {
        width: 5rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.5rem;
        margin-top: 2rem;
        img {
          object-fit: contain;
          padding: 0.5rem;
          height: 4rem;
          width: 4rem;
          background: rgb(242, 242, 242);
          border: 0.001rem solid rgb(207, 207, 207);
          border-radius: 0.5rem;
        }
        .name {
          text-align: center;
          font-size: 0.8rem;
          color: #aaa;
        }
      }
    }
  }
  .operations {
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-direction: column;
    gap: 1.5rem;
    margin-top: 2rem;
  }
}
.rules {
  margin-top: 1rem;
  .rule-content {
    margin-top: 1rem;
    color: #aaa;
    :deep(p) {
      line-height: 1.5rem !important;
    }
  }
}
</style>
